module.exports = __webpack_public_path__ + "static/condo_design-banner-7a7f33c0a8e2d4407cb19fa890441144.jpg";